import { axiosInterceptors } from '~/utils/axiosInterceptor'

class ScApi {
	constructor(axios, baseUrl) {
		this.axios = axios
		this.baseUrl = baseUrl
	}

	getUser(token, playerTag) {
		return this.axios.post(
			`${this.baseUrl}/user`,
			{ playerTag },
			{
				headers: {
					Authorization: token,
				},
			}
		)
	}

	registerUser(token, data, playerTag) {
		return this.axios.post(
			`${this.baseUrl}/register`,
			{ data, playerTag },
			{
				headers: {
					Authorization: token,
				},
			}
		)
	}

	getClanMembers(token, includeAll = false) {
		const url = includeAll ? `${this.baseUrl}/clan?includeAll=1` : `${this.baseUrl}/clan`
		return this.axios.get(url, {
			headers: {
				Authorization: token,
			},
		})
	}

	getPreviousClanMembers(token) {
		return this.axios.get(`${this.baseUrl}/clan/previous`, {
			headers: {
				Authorization: token,
			},
		})
	}

	// eslint-disable-next-line max-params
	inviteMembers(token, playerTag, members, segmentId) {
		const data = {
			playerTag,
			members,
			segmentId,
		}
		return this.axios.post(`${this.baseUrl}/members`, data, {
			headers: {
				Authorization: token,
			},
		})
	}

	pickCaptain(token, playerTag) {
		const data = {
			playerTag,
		}
		return this.axios.post(`${this.baseUrl}/captain`, data, {
			headers: {
				Authorization: token,
			},
		})
	}

	getDiscordAccessCode(token, playerTag) {
		return this.axios.post(
			`${this.baseUrl}/get-discord-token`,
			{ playerTag },
			{
				headers: {
					Authorization: token,
				},
			}
		)
	}

	getWeChatQrCode(rosterId) {
		return this.axios.get(`${this.baseUrl}/wechatqrcode/by-roster/${rosterId}`)
	}

	checkIfClanCanCheckIn(token) {
		return this.axios.get(`${this.baseUrl}/check-clan`, {
			headers: {
				Authorization: token,
			},
		})
	}

	checkSelectedPlayers(token) {
		return this.axios.get(`${this.baseUrl}/check-selected-players`, {
			headers: {
				Authorization: token,
			},
		})
	}

	confirmRoster(token) {
		return this.axios.post(
			`${this.baseUrl}/clan/roster/confirm`,
			{},
			{
				headers: {
					Authorization: token,
				},
			}
		)
	}

	segmentCheckInRoster(token, segmentId, playerTags) {
		return this.axios.post(
			`${this.baseUrl}/clan/roster/segment-check-in`,
			{
				segmentId,
				playerTags,
			},
			{
				headers: {
					Authorization: token,
				},
			}
		)
	}

	getClanAllowedChanges(token) {
		return this.axios.get(`${this.baseUrl}/clan/roster/allowed-changes`, {
			headers: {
				Authorization: token,
			},
		})
	}

	disbandClan(token, clanTag) {
		return this.axios.post(
			`${this.baseUrl}/disband-clan`,
			{
				clanTag,
			},
			{
				headers: {
					Authorization: token,
				},
			}
		)
	}
}

export default ({ $axios, $config }, inject) => {
	const scAxios = $axios.create({
		transformRequest: (data, headers) => {
			delete headers['X-Origin']
			delete headers.common['X-Origin']
			return JSON.stringify(data)
		},
	})

	axiosInterceptors(scAxios)
	inject('scApi', new ScApi(scAxios, $config.scBaseUrl))
}
